// extracted by mini-css-extract-plugin
module.exports = {"container":"new-cars-promo-banner_container__DSd5Y","pill":"new-cars-promo-banner_pill__sKTBR","text":"new-cars-promo-banner_text__r0RYa"};